import { BackrsFormValues } from '@backrs_ui/common-ui';

import { StickerCardId } from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { OnboardingFlow, ONBOARDING_CONFIGS } from '../onboarding.types';

export const getRecommendations = (
  formData: BackrsFormValues,
  onboardingType: OnboardingFlow,
): StickerCardId[] => {
  switch (onboardingType) {
    case 'student':
      return getDynamicRecommendations(formData, onboardingType);
    case 'adult':
      return getAdultEducatorRecommendations();
    case 'educator':
      return [
        ...getAdultEducatorRecommendations(),
        ...getDynamicRecommendations(formData, onboardingType),
      ];
    case 'employer':
      return getEmployerRecommendations();
  }
};

const getDynamicRecommendations = (
  formData: BackrsFormValues,
  onboardingType: OnboardingFlow,
): StickerCardId[] => {
  const recommendations: StickerCardId[] = [];
  // Get the questions configuration for the current onboarding type
  const questionsConfig = ONBOARDING_CONFIGS[onboardingType]();

  // Go through each value in the form data
  Object.values(formData).forEach((formValue) => {
    // Skip empty values
    if (!formValue) return;

    // Process each question to find options with recommendations
    Object.values(questionsConfig).forEach((question) => {
      if (question.question.type === 'CHECKBOX' || question.question.type === 'RADIO') {
        // Check if the current question has options with recommendations
        const options = question.question.options;

        // Convert form value to array for consistent handling
        const formValues = Array.isArray(formValue) ? formValue : [formValue];

        // Check each form value against the options
        formValues.forEach((value) => {
          const matchingOption = options.find((option) => option.value === value);

          // If we found a matching option with recommendations, add them
          if (matchingOption && matchingOption.recommendation) {
            recommendations.push(...matchingOption.recommendation);
          }
        });
      }
    });
  });

  // Remove duplicates using Set
  const uniqueRecommendations = Array.from(new Set(recommendations));

  return uniqueRecommendations;
};

// there is no logic here - we will always recommend
const getAdultEducatorRecommendations = (): StickerCardId[] => {
  const recommendations: StickerCardId[] = [
    'back_individual_student',
    'engage_in_networks',
    'explore_tools_dashboard',
    'respond_to_catch_up',
    'share_your_story_video_ask',
  ];

  return recommendations;
};

const getEmployerRecommendations = (): StickerCardId[] => {
  return [
    'respond_to_catch_up',
    'share_your_story_video_ask',
    'engage_in_networks',
    'back_individual_student',
    'explore_tools_dashboard',
  ];
};
